import React from 'react';

import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { GRANT_DOMAIN } from 'common/constants';
import Icon from 'common/components/Icon';
import { layout } from 'styles';

const HeaderLogo = () => {
    const { title, } = layout.makeHeaderStyles();

    return (
        <h1 className={title}>
            <Link href={GRANT_DOMAIN}
                  color="inherit"
                  underline="none">
                <Box display="flex"
                     flexBasis="180"
                     alignItems="center">
                    <Icon.LogoHeader />
                    <Box display="flex"
                         flexDirection="column"
                         pl={1}>
                        <Box component="span" fontSize={28}>Księgarnia</Box>
                        <Box component="span" fontSize={19}>dotacyjna GWO</Box>
                    </Box>
                </Box>
            </Link>
        </h1>
    );
};

export default HeaderLogo;
